module.exports = __webpack_public_path__ + "static/media/chophouse.dc638339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chophouse.jpg
// module id = 1609
// module chunks = 0